// The reviewer roster for block-v review items — who on the Yango side is asked to
// test a flow. Mirrors the skill's source of truth,
// .claude/skills/feature-review-sync/config/reviewers.json (the driver resolves the
// key to a Worktracker account at sync time). Kept as a small static list here so the
// board drawer can offer a proper picker; keep the two in step when the roster changes.

export interface ReviewReviewer {
  key: string;
  name: string;
}

// 5-person area-of-responsibility model Yango supplied (2026-08-13):
// Boaz = Catalog / PIM / GS1 / Pricing · Kirill = Finance / Customer approval /
// Identification · Omri = Darkstore / Inventory / WMS · Meital = Marlog (logistics
// centre) / Purchase orders / General orders · Roy = App & all other topics.
export const REVIEW_REVIEWERS: ReviewReviewer[] = [
  { key: "boaz", name: "Boaz" },
  { key: "kirill", name: "Kirill Shapiro (Kyril)" },
  { key: "omri", name: "Omri Zikorel" },
  { key: "meital", name: "Meital" },
  { key: "roy", name: "Roy" },
  { key: "unassigned", name: "Unassigned" },
];
